import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            students: [],
            lastFetch: null,
            currentStudentCreated: null,
            editStuentInfo: null
        }
    },
    mutations,
    actions,
    getters
}